module.exports = __webpack_public_path__ + "img/wufoo.7c847408.svg";